import { render, staticRenderFns } from "./Add.vue?vue&type=template&id=b278c54c&scoped=true"
import script from "./Add.vue?vue&type=script&lang=js"
export * from "./Add.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./Add.vue?vue&type=style&index=1&id=b278c54c&prod&scoped=true&lang=css"
import style2 from "./Add.vue?vue&type=style&index=2&id=b278c54c&prod&lang=scss"
import style3 from "./Add.vue?vue&type=style&index=3&id=b278c54c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b278c54c",
  null
  
)

export default component.exports